import { render } from "./expirationItemPanel.vue?vue&type=template&id=8bcc2572&scoped=true&ts=true"
import script from "./expirationItemPanel.vue?vue&type=script&lang=ts"
export * from "./expirationItemPanel.vue?vue&type=script&lang=ts"

import "./expirationItemPanel.vue?vue&type=style&index=0&id=8bcc2572&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bcc2572"]])

export default __exports__